import { DirectOrderLabelTextHelper } from './labelTextHelper/DirectOrderLabelTextHelper';
import { HeaderItem } from '../model/HeaderItem';

const excludedImportFieldList = [
    'trackingNumber',
    'directOrderStatus',
    'directOrderName',
    'directOrderPhone',
    'directOrderEmail',
    'directOrderAddress1',
    'directOrderAddress2',
    'directOrderAddress3',
    'directOrderPostalcode',
    'directOrderCity',
    'directOrderState',
    'directOrderCountry',
    'remarks',
    'customerReference',
    'dateCreateOn',
    'dateModifyOn'
];

export const DirectOrderHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderNumber, value: 'directOrderNumber' },
            { text: DirectOrderLabelTextHelper.getLabelText.trackingNumber, value: 'trackingNumber' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderStatus, value: 'directOrderStatus' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderName, value: 'directOrderName' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderPhone, value: 'directOrderPhone' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderEmail, value: 'directOrderEmail' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderAddress1, value: 'directOrderAddress1' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderAddress2, value: 'directOrderAddress2' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderAddress3, value: 'directOrderAddress3' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderPostalcode, value: 'directOrderPostalcode' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderCity, value: 'directOrderCity' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderState, value: 'directOrderState' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderCountry, value: 'directOrderCountry' },
            { text: DirectOrderLabelTextHelper.getLabelText.directOrderCourierCode, value: 'directOrderCourierCode' },
            { text: DirectOrderLabelTextHelper.getLabelText.carrierReference, value: 'carrierReference' },
            { text: DirectOrderLabelTextHelper.getLabelText.remarks, value: 'remarks' },
            { text: DirectOrderLabelTextHelper.getLabelText.customerReference, value: 'customerReference' },
            { text: DirectOrderLabelTextHelper.getLabelText.dateCreateOn, value: 'dateCreateOn', format: 'datetime' },
            { text: DirectOrderLabelTextHelper.getLabelText.dateModifyOn, value: 'dateModifyOn', format: 'datetime' }
        ];
    },

    getActionHeaderItem(): HeaderItem {
        return { text: DirectOrderLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportDirectOrderFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportDirectOrderHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
